
import { doGet, doPost, doDelete } from './Api';

export default class GalleryService {

  static async responseGetGallery() {
    const response = await doGet(`${process.env.REACT_APP_BASE_URL}/Gallery`);
    if(response.data.success){
      return response.data;
    }else{
      console.log("error");
    }
  }

  static async responseSavePhoto(data) {
    const response = await doPost(`${process.env.REACT_APP_BASE_URL}/Gallery`,data);
    if(response.data.success){
      return response.data;
    }else{
      console.log("error");
    }
  }

  static async responseDeletePhoto(id) {
    const response = await doDelete(`${process.env.REACT_APP_BASE_URL}/Gallery/${id}`);
    if(response.data.success){
      return response.data;
    }else{
      console.log("error");
    }
  }
}
